// ─── BLOOM PRODUCT TAXONOMY (v1) — single source of truth for the category menu ──
// Umbrella → subcategory. Slugs are STABLE ids stamped on products (taxonomy_cat /
// taxonomy_sub); labels are display text. The backend classifier (server.js
// classifyProduct) MUST produce these same slugs. App uses this same tree.
// Vibe/aesthetic tags are a separate phase-2 axis, not here yet.

export const TAXONOMY = [
  { slug: "jewellery", label: "Jewellery", icon: "jewellery", subs: [
    { slug: "earrings",   label: "Earrings" },
    { slug: "necklaces",  label: "Necklaces & Pendants" },
    { slug: "chokers",    label: "Chokers" },
    { slug: "rings",      label: "Rings" },
    { slug: "bracelets",  label: "Bracelets & Anklets" },
    { slug: "sets",       label: "Jewellery Sets" },
    { slug: "antitarnish",label: "Anti-tarnish" },
  ]},
  { slug: "hair", label: "Hair", icon: "accessories", subs: [
    { slug: "clips",      label: "Clips & Claws" },
    { slug: "scrunchies", label: "Scrunchies & Ties" },
    { slug: "combs",      label: "Combs & Pins" },
    { slug: "bows",       label: "Bows & Headbands" },
  ]},
  { slug: "charms", label: "Charms & Keychains", icon: "charms", subs: [
    { slug: "phone",      label: "Phone Charms" },
    { slug: "bag",        label: "Bag Charms" },
    { slug: "keychains",  label: "Keychains" },
    { slug: "beads",      label: "Beads & DIY" },
  ]},
  { slug: "apparel", label: "Apparel", icon: "apparel", subs: [
    { slug: "tops",       label: "Tops" },
    { slug: "dresses",    label: "Dresses" },
    { slug: "skirts",     label: "Skirts" },
    { slug: "bottoms",    label: "Bottoms" },
    { slug: "corsets",    label: "Corsets & Bodysuits" },
    { slug: "outerwear",  label: "Outerwear" },
    { slug: "coords",     label: "Co-ords" },
    { slug: "ethnic",     label: "Ethnic / Indian" },
  ]},
  { slug: "bags", label: "Bags & Purses", icon: "handbags", subs: [
    { slug: "coinpurses", label: "Coin Purses" },
    { slug: "totes",      label: "Totes & Shoulder" },
    { slug: "pouches",    label: "Pouches" },
  ]},
  { slug: "collectibles", label: "Collectibles & Paper", icon: "collectibles", subs: [
    { slug: "photocards",label: "Photocards" },
    { slug: "stickers",  label: "Stickers" },
    { slug: "badges",    label: "Pin Badges" },
    { slug: "prints",    label: "Prints & Posters" },
    { slug: "blindbox",  label: "Blind Boxes & Toys" },
  ]},
  { slug: "home", label: "Home & Objects", icon: "home", subs: [
    { slug: "magnets",   label: "Magnets" },
    { slug: "stationery",label: "Desk & Stationery" },
    { slug: "trinkets",  label: "Trinkets" },
    { slug: "candles",   label: "Candles" },
  ]},
  { slug: "beauty", label: "Beauty", icon: "beauty", subs: [
    { slug: "nails",     label: "Nails" },
    { slug: "beautyother",label: "Other" },
  ]},
  { slug: "bundles", label: "Bundles & Gifts", icon: "gift", subs: [
    { slug: "mystery",   label: "Mystery Boxes" },
    { slug: "hampers",   label: "Gift Hampers" },
    { slug: "bundlesets",label: "Bundles" },
  ]},
];

// Flat lookups
export const CAT_BY_SLUG = Object.fromEntries(TAXONOMY.map(c => [c.slug, c]));
export function subLabel(catSlug, subSlug) {
  const c = CAT_BY_SLUG[catSlug];
  return c?.subs.find(s => s.slug === subSlug)?.label || null;
}
export function catLabel(catSlug) { return CAT_BY_SLUG[catSlug]?.label || null; }
